import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Inject,
  inject,
  OnDestroy,
  Renderer2,
} from '@angular/core';
import { DOCUMENT, CommonModule } from '@angular/common';
import { Observable} from 'rxjs';

import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { SimplebarAngularModule } from 'simplebar-angular';
import {UserProfile} from "@common/model/user-profile.model";
import {LanguageService} from "@core/service/language.service";
import {AuthService} from "@core/auth/auth.service";
import {HabilitationService} from "@core/service/habilitation.service";
import {ReportService} from "@common/service/report.service";
import {
  DropdownNotificationComponent
} from "@modules/backoffice/notification-context/notification/dropdown-notification/dropdown-notification.component";
import {HasAnyRoleDirective} from "@shared/directives/has-any-role.directive";
import {HasAnyAccessDirective} from "@shared/directives/has-any-access.directive";
import { DelegationDropdownComponent } from '@shared/components/delegation-dropdown/delegation-dropdown.component';
import {RouterModule} from "@angular/router";
import {routes} from "../../app.routes";



@Component({
  standalone: true,
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
  imports: [
    CommonModule,
    NgbDropdownModule,
    FormsModule,
    HasAnyRoleDirective,
    HasAnyAccessDirective,
    SimplebarAngularModule,
    DropdownNotificationComponent,
    RouterModule,
    DelegationDropdownComponent
  ],
})
export class TopbarComponent implements OnInit {
  currLang = 'fr';
  userInfos?: Observable<UserProfile | undefined>;

  languageService = inject(LanguageService);
  authService = inject(AuthService);
  renderer = inject(Renderer2);
  habilitationService = inject(HabilitationService);
  reportService = inject(ReportService);


  element: any;

  isDocxEnabled: boolean = false;

  @Output() mobileMenuButtonClicked = new EventEmitter();
  enableEdit = this.habilitationService.enableEdit;


  constructor(@Inject(DOCUMENT) private document: any) {}

  ngOnInit(): void {


    this.languageService.getCurrent().subscribe((lang) => {
      this.currLang = lang;
      this.updatePageDirection();
    });

    this.userInfos = this.authService.getProfile();

    this.element = document.documentElement;
  }


  windowScroll() {
    if (
      (document.body.scrollTop > 100 ||
        document.documentElement.scrollTop > 100) &&
      document.getElementById('back-to-top')
    ) {
      if (document.getElementById('back-to-top')) {
        (document.getElementById('back-to-top') as HTMLElement).style.display =
          'block';
      }
      document.getElementById('page-topbar')?.classList.add('topbar-shadow');
    } else {
      if (document.getElementById('back-to-top')) {
        (document.getElementById('back-to-top') as HTMLElement).style.display =
          'none';
      }
      document.getElementById('page-topbar')?.classList.remove('topbar-shadow');
    }
  }

  setLanguage(lang: string) {
    this.languageService.changeLanguage(lang);
  }

  toggleLanguageEdit() {
    this.languageService.toggleEdit();
  }

  translationEdit() {
    return this.languageService.isEdit();
  }

  private updatePageDirection(): void {
    const topbar = document.getElementById('page-topbar');
    if (topbar) {
      this.renderer.setAttribute(
        topbar,
        'data-layout-direction',
        this.currLang === 'ar' ? 'rtl' : 'ltr'
      );
    }

    const navbarHeader = document.querySelector('.navbar-header');
    if (navbarHeader) {
      if (this.currLang === 'ar') {
        this.renderer.addClass(navbarHeader, 'rtl-mode');
      } else {
        this.renderer.removeClass(navbarHeader, 'rtl-mode');
      }
    }

    this.loadStyle(this.currLang);
  }

  loadStyle(styleName: string) {
  }

  toggleMobileMenu(event: any) {
    document.querySelector('.hamburger-icon')?.classList.toggle('open');
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  fullscreen() {
    document.body.classList.toggle('fullscreen-enable');
    if (
      !document.fullscreenElement &&
      !this.element.mozFullScreenElement &&
      !this.element.webkitFullscreenElement
    ) {
      if (this.element.requestFullscreen) {
        this.element.requestFullscreen();
      } else if (this.element.mozRequestFullScreen) {
        this.element.mozRequestFullScreen();
      } else if (this.element.webkitRequestFullscreen) {
        this.element.webkitRequestFullscreen();
      } else if (this.element.msRequestFullscreen) {
        this.element.msRequestFullscreen();
      }
    } else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        this.document.msExitFullscreen();
      }
    }
  }

  onNotificationsUpdated(): void {
  }


  toggleAccessEdit() {
    this.habilitationService.toggleEdit();
  }

  toggleDocxFormat(): void {
    this.reportService.setIsDocx(this.isDocxEnabled);
  }

  logout(e: Event) {
    e.preventDefault();
    this.authService.logout();
  }
}
